import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchNotifications = createAsyncThunk('notifs/fetch', async (params = {}) => {
  const { data } = await api.get('/notifications/', { params });
  return data;
});
export const envoyerNotification = createAsyncThunk('notifs/envoyer', async (payload, { rejectWithValue }) => {
  try { const { data } = await api.post('/notifications/', payload); return data; }
  catch (e) { return rejectWithValue(e.response?.data); }
});

const notifSlice = createSlice({
  name: 'notifications',
  initialState: { liste: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchNotifications.pending,   (s) => { s.loading = true; })
     .addCase(fetchNotifications.fulfilled, (s, { payload }) => {
       s.loading = false; s.liste = payload.results || payload;
     })
     .addCase(envoyerNotification.fulfilled, (s, { payload }) => { s.liste.unshift(payload); });
  },
});
export default notifSlice.reducer;
